import React, { useState } from 'react'
import useInterval from 'utils/useInterval';
import { formatDateYYYYMMDDHHMMSS } from '../../utils/dateFormat'
import dayjs from 'dayjs'
import {StyledDetailInfo} from '../../Views/Farm2/staking/StakeDetail'

export default function TimeCounter({ option }) {
    const [stakeDate, setStakeDate] = useState(new Date())

    useInterval(() => {
        setStakeDate(new Date())
    }, 2000)
    return (
        <>
            <StyledDetailInfo>
                <div>Stake Date</div>
                <div className='value'>{formatDateYYYYMMDDHHMMSS(stakeDate)}</div>
            </StyledDetailInfo>
            <StyledDetailInfo>
                <div>Interest End Date</div>
                <div className='value'>
                    {formatDateYYYYMMDDHHMMSS(dayjs(stakeDate).add(option.duration, 'day'))}
                </div>
            </StyledDetailInfo>
        </>
    )
}
